import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLMenu, Icon, Table } from 'appSrc/components/UI';
import EditAdvertiserModal from '../../Modals/Advertiser/EditAdvertiserModal';
import style from './styles/style.module.css';

class MissingDomainsTable extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            recordIndexInEdit: null,
        };
    }
    openEditModal = ( recordIndex ) => {
        this.setState( { recordIndexInEdit: recordIndex } );
    }
    onEditSubmit = ( updatedAdvertiser ) => {
        let recordDeleted = ( updatedAdvertiser === undefined );
        let addedDomains = ( updatedAdvertiser && updatedAdvertiser.advertisers_domains.length > 0 );
        let updatedRecordIndex = this.state.recordIndexInEdit;

        this.setState( { recordIndexInEdit: null }, () => {
            // if updated advertiser has domains or advertiser was deleted, remove it from the list
            if ( recordDeleted || addedDomains ) {
                this.props.removeRecordFromUI && this.props.removeRecordFromUI( updatedRecordIndex );
            }
            // for an updated advertiser that still has no domains, update the record
            else if ( updatedAdvertiser ) {
                this.props.updateRecordFromUI && this.props.updateRecordFromUI( updatedRecordIndex, updatedAdvertiser );
            }
        } );
    }
    onEditClose = () => {
        this.setState( { recordIndexInEdit: null } );
    }
    render() {
        const { dbRecordsLackingDomains } = this.props;
        const { recordIndexInEdit } = this.state;

        let recordInEdit = ( recordIndexInEdit !== null ) ? dbRecordsLackingDomains[ recordIndexInEdit ] : null;

        return (
            <div>
                <div className={ style.dataHeader }>Missing Domains</div>
                <Table>
                    <Table.Head>
                        <Table.Row>
                            <Table.Cell>AFFILIATE TYPE</Table.Cell>
                            <Table.Cell>ADVERTISER ID</Table.Cell>
                            <Table.Cell>ADVERTISER NAME</Table.Cell>
                            <Table.Cell>DOMAINS</Table.Cell>
                            <Table.Cell>ACTIONS</Table.Cell>
                        </Table.Row>
                    </Table.Head>
                    <Table.Body>
                        { dbRecordsLackingDomains &&
                            dbRecordsLackingDomains.map( ( record, index ) => {
                                return (
                                    <Table.Row key={`${ record.affiliate }-${ record.advertiserId }-${index}`}>
                                        <Table.Cell>{ record.affiliate }</Table.Cell>
                                        <Table.Cell>{ record.advertiserId }</Table.Cell>
                                        <Table.Cell>{ record.advertiserName }</Table.Cell>
                                        <Table.Cell>No domains found.</Table.Cell>
                                        <Table.Cell>
                                            <DLMenu
                                            icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                                            direction='left' >
                                                <DLMenu.Item text='Edit'
                                                onClick={ () => {
                                                    this.openEditModal( index );
                                                } }/>
                                            </DLMenu>
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            } )
                        }
                    </Table.Body>
                </Table>
                { recordInEdit &&
                    <EditAdvertiserModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    advertiser={ {
                        advertiserid: recordInEdit.dbAdvertiserId,
                        advertiser_name: recordInEdit.advertiserName,
                        advertisers_domains: [],
                    } }
                    affiliateType={ recordInEdit.affiliate } />
                }
            </div>
        );
    }
}

export default connect()( MissingDomainsTable );
